import { computed, ref, watch } from 'vue';
import useFacets from './useFacets';
import { isNotDeliveryAndPickupFacet } from '../utils/deliveryAndPickupUtil';

export default function useAccordionTabs(selections, facetRowsNumber, accordionActiveIndex) {
  const {
    globalOptions,
  } = useFacets();
  const { isSYS } = globalOptions;

  const facetRowsExpanded = ref(false);

  const toggleFacetRows = (val) => {
    facetRowsExpanded.value = val;
  };

  watch(accordionActiveIndex, (val) => {
    /* istanbul ignore else */
    if (val > facetRowsNumber.value) {
      facetRowsExpanded.value = true;
    }
  }, { immediate: true });

  watch(() => selections.value.facets, (newVal) => {
    // set expanded if facets number <= 8 and not expanded already
    /* istanbul ignore else */
    if (!facetRowsExpanded.value && Array.isArray(newVal) && !!newVal.length) {
      const expanded = newVal.length <= facetRowsNumber.value;
      toggleFacetRows(expanded);
    }
  });

  const accordionTabs = computed(() => {
    let tabs;
    if (!isSYS.value) {
      const _tabs = selections.value.facets;
      tabs = !facetRowsExpanded.value && Number.isInteger(facetRowsNumber.value) ? _tabs.slice(0, facetRowsNumber.value) : _tabs;
    } else {
      tabs = selections.value.facets.filter(isNotDeliveryAndPickupFacet);
    }

    return tabs.map((facet) => ({
      id: facet.displayName,
      header: facet.name,
      facet,
    }));
  });

  return {
    accordionTabs,
    facetRowsExpanded,
    toggleFacetRows,
  };
}
